import React from "react";
import "./commonCta.scss";
import { Link } from "react-router-dom";

const CommonCta = ({ link, text, linkCta, externalLink }) => {
  return (
    <>
      <section className="comm_cta_sec1">
        {linkCta ? (
          externalLink ? (
            <a
              href={link}
              target="_blank"
              rel="noreferrer"
              className="cta_link"
            >
              <span className="cta_text">{text}</span>{" "}
            </a>
          ) : (
            <Link to={link} className="cta_link">
              <span className="cta_text">{text}</span>{" "}
            </Link>
          )
        ) : (
          <button className="cta_link">
            <span className="cta_text">{text}</span>{" "}
          </button>
        )}
      </section>
    </>
  );
};

export default CommonCta;
